module.exports = window.VueRouter;